import { memo, useMemo } from 'react';
import { cn, Price as PriceUI } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import styles from './Price.module.css';

import type { TariffData } from '@Pages/PageExpressDesign/type';
import type { FC, HTMLAttributes } from 'react';

interface PriceProps extends HTMLAttributes<HTMLDivElement> {
  selectedType: string;
  selectedTariff?: TariffData;
}

const Price: FC<PriceProps> = (props) => {
  const { className, selectedType, selectedTariff } = props;
  const { t } = useTranslation();
  const selectedTab = selectedTariff.tabs.find((tab) => tab.name === selectedType);

  const selectedPrice = useMemo(() => {
    if (selectedTab?.price?.value) return selectedTab.price.value;

    const prices = selectedTariff.tabs.map((tab) => tab.price?.value);

    return prices.length ? Math.min(...prices) : null;
  }, [selectedTariff, selectedTab]);

  const text = useMemo(
    () => `${t('form.price.price')} ${!selectedTab ? `${t('form.price.preposition')} ` : ''}`,
    [selectedTab, t],
  );

  return (
    <div className={cn(styles.main, className)}>
      {selectedPrice ? (
        <>
          {text}
          <PriceUI price={selectedPrice} />
        </>
      ) : (
        t('form.price.on-request')
      )}
    </div>
  );
};

export default memo(Price);
